// A clickable table row opens on Enter / Space only when the key went to the row itself: Enter on a link or a button inside the row
// keeps that control's own action (the player link, the "Sửa" button).
export function rowActivates(key: string, target: unknown, currentTarget: unknown): boolean {
  return (key === 'Enter' || key === ' ') && target === currentTarget;
}
